var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H12.5V2.99955L14 2.9993V13H12.5V14H14C14.5515 14 15 13.5515 15 13V3C15 2.4485 14.5515 2 14 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C8.55228 9.5 9 9.05228 9 8.5C9 7.94772 8.55228 7.5 8 7.5C7.44772 7.5 7 7.94772 7 8.5C7 9.05228 7.44772 9.5 8 9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2V14C11 14.5515 10.5515 15 10 15H2C1.4485 15 1 14.5515 1 14V2C1 1.4485 1.4485 1 2 1H10C10.5515 1 11 1.4485 11 2ZM2 14H10V1.99925L2 2V14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentError);
export default __webpack_public_path__ + "static/media/ic-document-error.502dc11009510fba0557f0b5a91a22b8.svg";
export { ForwardRef as ReactComponent };